import {
  useMutationStripeOnboardAccount,
  useQueryStripeAccountSession,
} from "@gymflow/api";
import {
  AppearanceOptions,
  loadConnectAndInitialize,
} from "@stripe/connect-js";
import { useContext, useEffect, useState } from "react";

import { useClubSettings } from "../providers";
import { ApiResolverContext } from "../providers/ApiResolverProvider/ApiResolverContext";
import useGymflowModels from "../store";

export function useStripeConnect() {
  const { club, properties } = useClubSettings();
  const { clubId } = useContext(ApiResolverContext);
  const isOnboarded = club.stripeAccountType === "CONNECTED";
  const [stripeConnectInstance, setStripeConnectInstance] = useState<any>();

  const { api } = useGymflowModels();
  const mutation = useMutationStripeOnboardAccount({ api });
  const { refetch } = useQueryStripeAccountSession(
    { api, clubId },
    { enabled: isOnboarded },
  );

  const appearance: AppearanceOptions = {
    overlays: "dialog",
    variables: {
      fontSizeBase: "18px",
      colorPrimary: "#8746EC",
    },
  };

  useEffect(() => {
    if (properties.stripeOnboardPublicKey && !isOnboarded) {
      const fetchClientSecret = async () => {
        const secret = await mutation.mutateAsync({ clubId });
        return secret;
      };

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: properties.stripeOnboardPublicKey,
          fetchClientSecret,
          appearance,
        }),
      );
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId, properties.stripeOnboardPublicKey]);

  useEffect(() => {
    if (properties.stripeOnboardPublicKey && isOnboarded) {
      const fetchClientSecret = async () => {
        const response = await refetch();
        return response.data as string;
      };

      setStripeConnectInstance(
        loadConnectAndInitialize({
          publishableKey: properties.stripeOnboardPublicKey,
          fetchClientSecret,
          appearance,
        }),
      );
    }
    // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clubId, properties.stripeOnboardPublicKey]);

  return stripeConnectInstance;
}
